module.exports = __webpack_public_path__ + "assets/img/banner.d2901d69.jpg";